// @mui
import {
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import Iconify from '../../components/Iconify';

export default function CoreTimeGuideDialog({ isOpen, closeDialog, editCoreTime }) {
  const smUp = useResponsive('up', 'sm');
  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          코어 타임을 등록해 주세요.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          계약을 갱신할 때마다 코어 타임을 등록해 주셔야 합니다.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ m: { xs: 0, sm: 1 } }}>
        <Button
          size="large"
          onClick={closeDialog}
        >
          취소
        </Button>
        <Button
          variant="contained"
          onClick={editCoreTime}
          size="large"
          sx={{ px: 4 }}
        >
          등록하기
        </Button>
      </DialogActions>
    </Dialog>
  )
};
